import { mergeStyles } from "@fluentui/react/";

export const dropDownS = mergeStyles({
    marginBottom: 15
  })